import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientHelperService } from './http-client-helper.service';
import { AssessmentCustomLabel, AssessmentResourceId } from './models/assessments/assessment.interface';

@Injectable({
  providedIn: 'root'
})
export class BaseApiClientLabelsService {
	protected readonly controller: string = 'assessment/v2/tags';

	constructor(protected httpClientHelper: HttpClientHelperService) { }
  
  getLabels(): Observable<AssessmentCustomLabel[]> {
    return this.httpClientHelper.invokeGetAuth<AssessmentCustomLabel[]>(`${this.controller}`);
  }

  createLabel(label: AssessmentCustomLabel): Observable<AssessmentCustomLabel> {
    return this.httpClientHelper.invokePostAuth<AssessmentCustomLabel>(`${this.controller}`, label);
  }

  updateLabel(id: AssessmentResourceId, label: AssessmentCustomLabel): Observable<AssessmentCustomLabel> {
    return this.httpClientHelper.invokePatchAuth<AssessmentCustomLabel>(`${this.controller}/${id}`, label);
  }

  deleteLabel(id: AssessmentResourceId): Observable<void> {
    return this.httpClientHelper.invokeDeleteAuth<void>(`${this.controller}/${id}`);
  }
}
